import { Controller } from "@hotwired/stimulus"

// Screen 2 of the onboarding routine insights: animates the projected score
// ring from the user's current routine score up to the projected score. The
// left "Today" ring renders static; only the delta animates. Skipped under
// prefers-reduced-motion.
export default class extends Controller {
    static targets = ["scoreNumber"]

    connect() {
        if (!this.hasScoreNumberTarget) return

        this.from = parseInt(this.scoreNumberTarget.dataset.fromScore, 10) || 0
        this.to = parseInt(this.scoreNumberTarget.dataset.toScore, 10) || 0

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this.scoreNumberTarget.textContent = this.to
            return
        }

        this.scoreNumberTarget.textContent = this.from
        this.timer = setTimeout(() => this.countUp(), 800)
    }

    disconnect() {
        if (this.timer) clearTimeout(this.timer)
    }

    countUp() {
        const duration = 1100
        const span = this.to - this.from
        let start = null

        const step = (now) => {
            if (start === null) start = now
            const progress = Math.min((now - start) / duration, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            this.scoreNumberTarget.textContent = Math.round(this.from + span * eased)
            if (progress < 1) requestAnimationFrame(step)
        }
        requestAnimationFrame(step)
    }
}
